import { render } from "./EmbassadorProgressTable.vue?vue&type=template&id=f241ccbc"
import script from "./EmbassadorProgressTable.vue?vue&type=script&lang=js"
export * from "./EmbassadorProgressTable.vue?vue&type=script&lang=js"
script.render = render

export default script